// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"styles__wrapper___d-iXF","bar":"styles__bar___1FDeW","rotate":"styles__rotate___2hm2u","fadein":"styles__fadein___3x9Gp","slideFromRight":"styles__slideFromRight___Z7snb","waves":"styles__waves___1RI7P"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/SearchBar/styles.scss
// module id = ./resources/assets/js/components/SearchBar/styles.scss
// module chunks = 0